var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 41,
    viewBox: "0 0 34 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0198233 0.01894C0.00849572 0.0271797 0 9.18888 0 20.3752V40.7123H4.8992H9.79839V25.3558V9.99929H19.8488H29.8993L29.9332 9.90863C29.9955 9.73831 30.5053 8.3098 30.5563 8.15871C30.5846 8.07629 30.7318 7.66147 30.8819 7.23841C31.1538 6.47196 31.2784 6.12582 31.4908 5.52145C31.5531 5.34838 31.6494 5.07642 31.706 4.91708C31.7627 4.75775 31.8816 4.41711 31.9722 4.16162C32.0628 3.90339 32.2667 3.32924 32.4253 2.8842C32.8586 1.66722 33.0059 1.24416 33.2041 0.686493C33.3004 0.406284 33.3938 0.145306 33.4108 0.106846C33.4278 0.0656395 33.4335 0.0244331 33.425 0.0161896C33.3995 -0.0057869 0.0424786 -0.0057869 0.0198233 0.01894Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0911 21.2294L13.0996 29.6302L16.2232 29.6384L19.344 29.6439V24.6579V19.6718H25.3051C28.5845 19.6718 31.2663 19.6663 31.2663 19.6553C31.2663 19.6416 31.1728 19.1636 30.9859 18.2296C30.9406 18.0016 30.8613 17.6142 30.8132 17.3642C30.7622 17.1142 30.6857 16.7241 30.6404 16.4989C30.5951 16.2709 30.4167 15.3753 30.244 14.5072C30.074 13.6391 29.9268 12.9056 29.9183 12.8781C29.9041 12.8342 29.4793 12.8314 21.4934 12.8314H13.0854L13.0911 21.2294Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0854 36.4267V40.7123H23.269C32.9569 40.7123 33.4525 40.7095 33.4327 40.6628C33.4242 40.6381 33.3053 40.2947 33.1722 39.9019C33.0391 39.509 32.8578 38.9706 32.7672 38.7069C32.6766 38.4431 32.4104 37.652 32.1725 36.9487C31.9346 36.2454 31.5891 35.2262 31.405 34.6823C31.221 34.1384 30.9519 33.3445 30.8075 32.9159L30.547 32.1412H21.8162H13.0854V36.4267Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.9aed880ae20c4bea33e3a0a9b8255852.svg";
export { ForwardRef as ReactComponent };